/**
 * Haversine distance between two lat/lng points in kilometers.
 *
 * @param {{ lat: number, lng: number }} a
 * @param {{ lat: number, lng: number }} b
 * @returns {number}
 */
export function haversineKm(a, b) {
  const R = 6371;
  const dLat = ((b.lat - a.lat) * Math.PI) / 180;
  const dLng = ((b.lng - a.lng) * Math.PI) / 180;
  const x =
    Math.sin(dLat / 2) ** 2 +
    Math.cos((a.lat * Math.PI) / 180) *
      Math.cos((b.lat * Math.PI) / 180) *
      Math.sin(dLng / 2) ** 2;
  return 2 * R * Math.asin(Math.sqrt(x));
}

/**
 * Human-readable proximity label for admin review.
 *
 * @param {number} distanceKm
 * @returns {string}
 */
export function formatGeoProximityLabel(distanceKm) {
  if (!Number.isFinite(distanceKm)) return "";
  if (distanceKm < 1) {
    const meters = Math.round(distanceKm * 1000);
    return `submitted ~${meters} m from facility`;
  }
  return `submitted ~${distanceKm.toFixed(1)} km from facility`;
}
